import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t py-8 px-6" style={{ borderColor: 'rgba(137,176,208,0.2)' }}>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Logo + copyright */}
        <div className="flex items-center gap-3">
          <AppLogo text="Hemato" iconName="BeakerIcon" size={24} />
          <span className="text-sm font-medium" style={{ color: '#8A9AAA' }}>
            © 2026 Hemato
          </span>
        </div>

        {/* Links */}
        <div className="flex items-center gap-8">
          {['Privacy', 'Terms', 'Contact', 'Referrals'].map((item) => (
            <a
              key={item}
              href="#"
              className="text-sm font-medium transition-colors duration-200"
              style={{ color: '#8A9AAA' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#3B4856')}
              onMouseLeave={(e) => (e.currentTarget.style.color = '#8A9AAA')}
            >
              {item}
            </a>
          ))}
        </div>

        {/* Social */}
        <div className="flex items-center gap-3">
          {/* LinkedIn */}
          <a
            href="#"
            aria-label="LinkedIn"
            className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200"
            style={{ border: '1px solid rgba(137,176,208,0.3)', color: '#8A9AAA' }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.background = '#3B4856';
              (e.currentTarget as HTMLElement).style.color = '#F4F7FA';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.background = 'transparent';
              (e.currentTarget as HTMLElement).style.color = '#8A9AAA';
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
              <circle cx="4" cy="4" r="2" />
            </svg>
          </a>
          {/* Twitter/X */}
          <a
            href="#"
            aria-label="Twitter"
            className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200"
            style={{ border: '1px solid rgba(137,176,208,0.3)', color: '#8A9AAA' }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.background = '#3B4856';
              (e.currentTarget as HTMLElement).style.color = '#F4F7FA';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.background = 'transparent';
              (e.currentTarget as HTMLElement).style.color = '#8A9AAA';
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}